import L from 'leaflet';
import { showLayerErrorToast } from '../../Toast/toast';

const defaultOptions: L.WMSOptions = {
    layers: 'bicycleroads_gbg_1,bicycleroads_gbg_2',
    format: 'image/png',
    transparent: true,
    noWrap: true,
};

export const bikeRoadsGbg = function (mapServerUrl: string, mapTilesVersion: number, options?: L.WMSOptions): L.TileLayer.WMS {
    const layer = L.tileLayer.wms(`${mapServerUrl}wms.axd/gbg_bicycle_view?v=${mapTilesVersion}`, { ...defaultOptions, ...options });

    layer.on('tileerror', () => {
        showLayerErrorToast('Cykelvägar');
    });

    return layer;
};
